<ng-container *ngIf="mostrarCampana">
<div class="bell-wrapper">
  <button
    type="button"
    class="bell-trigger"
    (click)="abrirModal()"
    [attr.aria-label]="'Centro de notificaciones. ' + ((conteoNoLeidas$ | async) || 0) + ' no leídas'"
    title="Notificaciones"
  >
    <lucide-angular name="bell" aria-hidden="true"></lucide-angular>
    <span
      *ngIf="(conteoNoLeidas$ | async) as count"
      class="bell-badge"
      aria-hidden="true"
    >
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>
</div>

<!-- Modal descriptivo / preview segun Figma Perfil Postulante_Notificaciones_Modal.svg -->
<div
  class="modal-backdrop"
  *ngIf="modalAbierto"
  (click)="cerrarModal()"
  role="presentation"
>
  <div
    class="modal-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
    (click)="$event.stopPropagation()"
  >
    <header class="modal-header">
      <div class="modal-title-wrap">
        <h2 id="modal-title">Notificaciones</h2>
        <span class="modal-count-badge" *ngIf="(conteoNoLeidas$ | async) as count">
          {{ count }} pendiente{{ count === 1 ? '' : 's' }}
        </span>
      </div>
      <button
        type="button"
        class="modal-close"
        (click)="cerrarModal()"
        aria-label="Cerrar modal de notificaciones"
      >
        <lucide-angular name="x" aria-hidden="true"></lucide-angular>
      </button>
    </header>

    <div class="modal-body">
      <ng-container *ngIf="(notificaciones$ | async) as items">
        <div class="modal-list" *ngIf="items.length > 0; else sinNotificaciones">
          <article
            *ngFor="let item of items.slice(0, 3)"
            class="preview-card"
            [class.preview-card-unread]="!item.leida"
          >
            <div class="card-top">
              <span class="date-stamp">{{ formatoFecha(item.fecha) }}</span>
              <span class="chip-status" [class.chip-unread]="!item.leida" [class.chip-read]="item.leida">
                {{ item.leida ? 'Leída' : 'No leída' }}
              </span>
            </div>

            <div class="card-content">
              <div class="title-row">
                <span class="blue-dot" *ngIf="!item.leida" aria-label="No leída"></span>
                <h3 class="card-title">{{ item.titulo }}</h3>
              </div>
              <p class="card-desc">{{ item.detalle || item.titulo }}</p>
            </div>

            <div class="card-actions">
              <button
                type="button"
                class="btn-detail"
                (click)="abrirDetalle(item)"
              >
                Ver detalles <span class="action-icon" aria-hidden="true">⊕</span>
              </button>
            </div>
          </article>
        </div>
      </ng-container>

      <ng-template #sinNotificaciones>
        <div class="empty-state">
          <p>No tienes notificaciones pendientes.</p>
        </div>
      </ng-template>
    </div>

    <footer class="modal-footer">
      <button
        type="button"
        class="btn-view-all"
        (click)="irATodas()"
      >
        Ver todas las notificaciones pendientes
      </button>
    </footer>
  </div>
</div>
</ng-container>
